import { render, staticRenderFns } from "./HomeFeaturedPosts.vue?vue&type=template&id=6b479596&"
import script from "./HomeFeaturedPosts.vue?vue&type=script&lang=js&"
export * from "./HomeFeaturedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports